import { AcceptProjectInvitation } from '@prodelio/modules/projects/features/accept-project-invitation/AcceptProjectInvitation';

export const AcceptProjectInvitationPage = () => {
  return <AcceptProjectInvitation />;
};
